











import { Component, Vue } from 'vue-property-decorator';
import Highcharts from 'highcharts';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import KnowledgeChunks from '@/trials/domain/objects/knowledgeChunks';
import KCSummary from '@/trials/views/components/KCSummary.vue';

@Component({ components: { KCSummary } })
export default class TrainResultKC extends Vue {
    /*----------------------------------*
     * Props
     *-----------------------------------*/
    /*----------------------------------*
     * Data
     *-----------------------------------*/
    private selected: number = 1;
    private kcList: KnowledgeChunks | null = null;
    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/
    created() {
        this.kcList = sessionModule.getKCListData;
    }
    /*----------------------------------*
     * Methods
     *-----------------------------------*/
}
